export const LINKS_SSO_ON = 'LINKS_SSO_ON';
export const LINKS_SSO_OFF = 'LINKS_SSO_OFF';

export const ssoOn = (slug) => async (dispatch) => {
  dispatch({
    type: LINKS_SSO_ON,
  });
};

export const ssoOff = (slug) => async (dispatch) => {
  dispatch({
    type: LINKS_SSO_OFF,
  });
};
